export enum DataStateDisplay {
  OkNoData = '-',
  Error = '⚠️',
  ErrorFetch = '⚠️',
  Loading = '⏳ Loading...',
}
